import LoginWithTooltipContainer from '../../../../Componant/OtherPages/Authentication/LoginWithTooltip/LoginWithTooltip'

const LoginWithTooltip = () => {
  return (
    <div className='page-body'>
      <LoginWithTooltipContainer />
    </div>
  )
}

export default LoginWithTooltip